import { render, staticRenderFns } from "./ProjectVersionActionsDelete.vue?vue&type=template&id=c0c7b37e&lang=pug&"
import script from "./ProjectVersionActionsDelete.vue?vue&type=script&lang=js&"
export * from "./ProjectVersionActionsDelete.vue?vue&type=script&lang=js&"
import style0 from "./ProjectVersionActionsDelete.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports